import { createFileRoute, redirect } from '@tanstack/react-router';

import { AgentsLaunchPage } from '@/features/agents/agents-launch-page';
import { isAgentsUxEnabled } from '@/features/agents/agents.utils';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/agents/new-task')({
  component: AgentsLaunchPage,
  beforeLoad: () => {
    if (!isAgentsUxEnabled()) {
      throw redirect({ to: Routes.Chats as string, replace: true });
    }
  },
});
